import axios from 'axios'
import { Notification, MessageBox, Message, Loading } from 'element-ui'
import store from '@/store'
import { getToken,removeToken } from '@/utils/auth'
import errorCode from '@/utils/errorCode'
import { tansParams, blobValidate } from "@/utils/sea"
import cache from '@/plugins/cache'
import { saveAs } from 'file-saver'
import qs from 'qs'

let downloadLoadingInstance
export let isRelogin = { show: false }

// 删掉全局默认json，统一在实例/请求单独控制
// axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8'

const service = axios.create({
  baseURL: "/",
  timeout: 30000,
  withCredentials: true // 必须开启，共享session验证码
})

// request拦截器
service.interceptors.request.use(config => {
  const isToken = (config.headers || {}).isToken === false
  const isRepeatSubmit = (config.headers || {}).repeatSubmit === false
  if (getToken() && !isToken) {
  config.headers['Authorization'] = 'Bearer ' + getToken()
}

// 统一转小写判断method，修复POST/Post匹配失效
const method = config.method.toLowerCase()
const contentType = config.headers['Content-Type']

// 表单类型自动序列化
if (method === 'post' && contentType === 'application/x-www-form-urlencoded') {
  config.data = qs.stringify(config.data)
}

// get参数拼接
if (method === 'get' && config.params) {
  let url = config.url + '?' + tansParams(config.params)
  url = url.slice(0, -1)
  config.params = {}
  config.url = url
}

// 防重复提交逻辑不变
if (!isRepeatSubmit && (method === 'post' || method === 'put')) {
  const requestObj = {
    url: config.url,
    data: typeof config.data === 'object' ? JSON.stringify(config.data) : config.data,
    time: new Date().getTime()
  }
  const requestSize = Object.keys(JSON.stringify(requestObj)).length
  const limitSize = 5 * 1024 * 1024
  if (requestSize >= limitSize) {
    console.warn(`[${config.url}]: 请求数据超出5M限制，跳过防重复校验`)
    return config
  }
  const sessionObj = cache.session.getJSON('sessionObj')
  if (!sessionObj) {
    cache.session.setJSON('sessionObj', requestObj)
  } else {
    const s_url = sessionObj.url
    const s_data = sessionObj.data
    const s_time = sessionObj.time
    const interval = 1000
    if (s_data === requestObj.data && requestObj.time - s_time < interval && s_url === requestObj.url) {
      const message = '数据正在处理，请勿重复提交'
      console.warn(`[${s_url}]: ${message}`)
      return Promise.reject(new Error(message))
    } else {
      cache.session.setJSON('sessionObj', requestObj)
    }
  }
}
return config
}, error => {
  console.log('请求拦截异常：', error)
  return Promise.reject(error)
})

// 响应拦截器
service.interceptors.response.use(res => {
  // 区分两种接口：后台管理标准接口(code数字200/401/500) 和 登录自定义Dto(code YES/0)
  const data = res.data
  // 二进制文件直接返回
  if (res.request.responseType === 'blob' || res.request.responseType === 'arraybuffer') {
  return data
}
// 登录/退出/首页初始化接口单独放行，不做全局200校验
if (res.config.url.includes('/login/go') || res.config.url.includes('/indexNew') || res.config.url.includes('/logout') || res.config.url.includes('/tallyCheck/findByZdNewxq')) {
  return data
}

// 其余后台标准接口正常走原有逻辑
const code = data.code || 200
const msg = errorCode[code] || data.msg || errorCode['default']
if (code === 401) {
  if (!isRelogin.show) {
    isRelogin.show = true
    MessageBox.confirm('登录状态已过期，您可以继续留在该页面，或者重新登录', '系统提示', {
      confirmButtonText: '重新登录',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(() => {
      isRelogin.show = false
      removeToken()
      // router.push('/lginindex')
      store.dispatch('user/LogOut').then(() => location.href = '/lginindex')
  }).catch(() => {
      isRelogin.show = false
    })
  }
  return Promise.reject('无效会话，请重新登录')
} else if (code === 500) {
  Message({ message: msg, type: 'error' })
  return Promise.reject(new Error(msg))
} else if (code === 601) {
  Message({ message: msg, type: 'warning' })
  return Promise.reject('error')
} else if (code !== 200 && code !== 1) {
  Notification.error({ title: msg })
  return Promise.reject('error')
} else {
  return data
}
}, error => {
  console.log('响应拦截完整异常：', error)
  let message = error.message
  if (message === "Network Error") {
    message = "后端接口连接异常"
  } else if (message.includes("timeout")) {
    message = "系统接口请求超时"
  } else if (message.includes("Request failed with status code")) {
    message = "系统接口" + message.substr(message.length - 3) + "异常"
  }
  Message({ message: message, type: 'error', duration: 5 * 1000 })
  return Promise.reject(error)
})

// 下载方法不变
export function download(url, params, filename, config) {
  downloadLoadingInstance = Loading.service({ text: "正在下载数据，请稍候", spinner: "el-icon-loading", background: "rgba(0, 0, 0, 0.7)", })
  return service.post(url, params, {
    transformRequest: [(params) => { return tansParams(params) }],
  headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
  responseType: 'blob',
...config
}).then(async (data) => {
    const isBlob = blobValidate(data)
    if (isBlob) {
      const blob = new Blob([data])
      saveAs(blob, filename)
    } else {
      const resText = await data.text()
      const rspObj = JSON.parse(resText)
      const errMsg = errorCode[rspObj.code] || rspObj.msg || errorCode['default']
      Message.error(errMsg)
    }
    downloadLoadingInstance.close()
  }).catch((r) => {
    console.error(r)
    Message.error('下载文件出现错误，请联系管理员！')
    downloadLoadingInstance.close()
  })
}

export default service
